interface IMultipostingSchema {
  enabled: boolean;
  /** Группа эксперимента **/
  group: string;
}

export interface IMultiPosting {
  isMultipostingAvailable: boolean;
  multipostingABGroup: string;
}

export const mapMultiposting = (multiposting: IMultipostingSchema): IMultiPosting => {
  if (!multiposting) {
    return {
      isMultipostingAvailable: false,
      multipostingABGroup: 'A',
    };
  }

  const { enabled: isMultipostingEnabled, group: multipostingABGroup } = multiposting;

  return {
    isMultipostingAvailable: Boolean(isMultipostingEnabled && multipostingABGroup && multipostingABGroup !== 'A'),
    multipostingABGroup: multipostingABGroup || 'A',
  };
};
